import { MakeCall } from 'ha/services/apiV2/createMakeCall';

const deleteListingVideos = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}/videos`);

export default deleteListingVideos;
